module.exports = __webpack_public_path__ + "static/media/015.1346eafe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/015.jpg
// module id = 362
// module chunks = 0